// Temporary: the Button variant showcase. Delete this folder to remove it.
import ButtonShowcasePage from "./ButtonShowcasePage"

export default {
  "/button-showcase": ButtonShowcasePage,
}
